import { MagnifyingGlassMinusIcon as PhosphorMagnifyingGlassMinusIcon } from "@phosphor-icons/react/dist/ssr/MagnifyingGlassMinus";

import { createAppIcon } from "@/components/createAppIcon";

export const SearchUnavailableIcon = /* @__PURE__ */ createAppIcon(
  PhosphorMagnifyingGlassMinusIcon,
);
